/* tslint:disable */
/* This file should be ignored by git and the .svg file checked in instead.
 * This file was generated with 'svg-gen'. Manual changes will be lost. */
import React from 'react';
import { createIcon } from '../../createIcon';
export var EmptyFormsIcon = createIcon("EmptyFormsIcon", function (title) {
  var _color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return /*#__PURE__*/React.createElement("svg", {
    width: "120",
    height: "120",
    viewBox: "0 0 120 120",
    fill: "none"
  }, /*#__PURE__*/React.createElement("title", null, title), /*#__PURE__*/React.createElement("path", {
    d: "M60 120c33.137 0 60-26.863 60-60S93.137 0 60 0 0 26.863 0 60s26.863 60 60 60Z",
    fill: "#CFCEFD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: ".35",
    d: "M61.005 34c1.102 0 1.995.887 1.995 1.998V37h11.994c1.108 0 2.006.903 2.006 1.997v55.006A2.001 2.001 0 0174.994 96H33.006A2.007 2.007 0 0131 94.003V38.997c0-1.103.898-1.997 2.006-1.997H45v-1.002c0-1.103.893-1.998 1.995-1.998h14.01Z",
    fill: "#A5AEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37 32.997c0-1.103.898-1.997 2.006-1.997h41.988c1.108 0 2.006.903 2.006 1.997v55.006A2.001 2.001 0 0180.994 90H39.006A2.007 2.007 0 0137 88.003V32.997Z",
    fill: "#0C0D0D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39 86.998A.997.997 0 0039.997 88h40.006c.55 0 .997-.443.997-1.002V34.002A.997.997 0 0080.003 33H39.997A.996.996 0 0039 34.002v52.996Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.499 68a.5.5 0 01.501.5l-.008.088a.507.507 0 01-.493.412H48.5a.5.5 0 110-1h23Zm0-8a.5.5 0 01.501.5l-.008.088a.507.507 0 01-.493.412H48.5a.5.5 0 110-1h23Zm0-8a.5.5 0 01.501.5l-.008.088a.507.507 0 01-.493.412H48.5a.5.5 0 110-1h23Z",
    fill: "#6D7478"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51 29.998c0-1.103.893-1.998 1.995-1.998h14.01c1.102 0 1.995.887 1.995 1.998v4.004A1.996 1.996 0 0167.005 36h-14.01A1.992 1.992 0 0151 34.002v-4.004Z",
    fill: "#0C0D0D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.007 30C53.45 30 53 30.443 53 31.01v1.98c0 .558.45 1.01 1.007 1.01h11.986C66.55 34 67 33.557 67 32.99v-1.98c0-.558-.45-1.01-1.007-1.01H54.007Z",
    fill: "#A5AEFF"
  }));
}, {
  "i18nKey": "svg.EmptyFormsIcon"
});